import React from 'react';
import { partners } from '../data/site';
export function Partners() {
  return <section id="sponsorship" aria-label="Partners and sponsors" className="border-y border-forest-line/60 bg-forest-deep py-10" data-id="element-85" data-mp="23jiyjo16x5p7">
      <div className="mx-auto max-w-shell px-5 sm:px-8" data-id="element-86" data-mp="1plkm4o6fjjcc">
        <p className="text-center text-xs uppercase tracking-widest2 text-cream-muted" data-id="element-87" data-mp="1uiksz1b3sq4i">
          Proudly supported by
        </p>
        <ul className="mt-7 flex flex-wrap items-center justify-center gap-x-10 gap-y-5" data-id="element-88" data-mp="2i9yjd1pp2bmu">
          {partners.map(partner => <li key={partner.name} data-id="element-89" data-mp="2mc3btx4ep27w">
              <a href={partner.href} target="_blank" rel="noopener noreferrer" className="font-display text-lg text-cream/60 transition-colors hover:text-cream focus:outline-none focus-visible:ring-2 focus-visible:ring-cream focus-visible:ring-offset-2 focus-visible:ring-offset-forest-deep" data-id="element-90" data-mp="28jdlxhlrbd5i">
                {partner.name}
              </a>
            </li>)}
        </ul>
      </div>
    </section>;
}